import React, { useRef } from "react";
import { TextBlocksRenderer } from "../TextBlocksRenderer";
import { Box, Radio, Typography } from "@mui/material";
import type { AnswerComponent } from "api/dist/models/AnswerComponent";
import type { BlocksContent } from "@strapi/blocks-react-renderer";

type DynamicFormSelectItemProps = {
  onChange: (id: number) => void;
  checked: boolean;
  answer: AnswerComponent | { id: number; text: string };
  disabled?: boolean;
  onBlur?: () => void;
};

export const DynamicFormSelectItem = (props: DynamicFormSelectItemProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const textIsBlocks = typeof props.answer.text !== "string";

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        gap: 2,
        border: `1px solid ${
          props.checked ? theme.palette.primary.main : theme.palette.divider
        }`,
        borderRadius: 2,
        padding: 0.5,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      })}
      onClick={() => props.onChange(props.answer.id)}
      onMouseUp={() => props.onBlur?.()}
    >
      <Box>
        <Radio
          onChange={() => props.onChange(props.answer.id)}
          value={props.answer.id}
          checked={props.checked}
          disabled={props.disabled}
        />
      </Box>
      <Box ref={ref}>
        {props.answer.text &&
          (textIsBlocks ? (
            <TextBlocksRenderer content={props.answer.text as BlocksContent} />
          ) : (
            <Typography>{props.answer.text as string}</Typography>
          ))}
      </Box>
    </Box>
  );
};
